<template>
  <div class="col-6 text-end" v-if="visible">
    <div class="popup_bg"></div>
    <div id="myModal" class="modal_class">
      <div class="modal-content invoice p-4 shadow-lg rounded">
        <div class="d-flex justify-content-center align-items-center mb-3">
          <h5 class="text-center m-0">Are you sure?</h5>
        </div>
        <div class="text-center">
          <button @click="$emit('confirm')" class="btn btn-danger w-40 mx-1">
            Yes, delete it!
          </button>
          <button @click="$emit('close')" class="btn btn-success w-40 mx-1">
            No, keep it
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DeletePopup",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

